import { ApplicationRef, Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs";
import { LocalStorageService } from "./local-storage.service";
import { MatIconRegistry } from "@angular/material/icon";

export const ThemeColor = {
    disabled: '#9e9e9e',
    primary: '#00acc1',
    accent: '#ef6c00',
}

@Injectable({
    providedIn: 'root'
})
export class ThemeService {

    themes = ["dark-theme", "light-theme"];
    theme = new BehaviorSubject("light-theme");


    constructor(private ref: ApplicationRef,
        localStorage: LocalStorageService,
        iconRegistry: MatIconRegistry) {
        iconRegistry.setDefaultFontSetClass(
            'material-symbols-outlined'
        );
        // lasciato solo il tema chiaro;
        // localStorage.darkModeOn = false;
        const isDarkModeOn = localStorage.darkModeOn == null && localStorage.darkModeOn;
        // this.theme.next((isDarkModeOn) ? "dark-theme" : "light-theme");
        this.theme.next("light-theme");
        // prende il tema predefinito del browser
        // const darkModeOn =
        // window.matchMedia &&
        // window.matchMedia("(prefers-color-scheme: dark)").matches;
        // localStorage.darkModeOn = darkModeOn;
        // watch for changes of the preference
        // window.matchMedia("(prefers-color-scheme: dark)").addListener(e => {
        //     const turnOn = e.matches;
        //     this.theme.next(turnOn ? "dark-theme" : "light-theme");
        //     // trigger refresh of UI
        //     this.ref.tick();
        // });
        // const darkModeOn = localStorage.darkModeOn;
        // if (darkModeOn) {
        //     this.theme.next("dark-theme");
        // }
    }
}
